import { IOption } from "@digital-services/ui";

import { EntityType, RelationshipType, ResourceType } from "@resource/models";

import { convertSearchQuery } from "../utils";
import { FilterOptions } from "./models";

interface CommonAttrs {
  searchQuery?: string;
  productFamilyNameFilter?: IOption | null;
  resourceTypeFilter?: IOption | null;
}

export class CreateFilterOptions {
  filterOptions: FilterOptions = {};

  constructor(attrs: CommonAttrs) {
    const { resourceTypeFilter, productFamilyNameFilter, searchQuery } = attrs;

    // same for Resources page and Organization \ Resources tab

    this.filterOptions.productFamilyName =
      productFamilyNameFilter?.value as string;

    this.filterOptions.resourceType = resourceTypeFilter?.value as ResourceType;

    if (searchQuery) {
      this.filterOptions.serialNumbers = convertSearchQuery(searchQuery);
    }
  }

  forPageResources(ownerFilter?: IOption | null) {
    this.filterOptions.entityId = ownerFilter?.value as string;
    this.filterOptions.entityType = EntityType.Organization;
    this.filterOptions.relationshipType = RelationshipType.Owner;
  }

  forTabResources(organizationId: string, relationshipFilter?: IOption | null) {
    this.filterOptions.entityId = organizationId.toLowerCase();
    this.filterOptions.entityType = EntityType.Organization;

    if (relationshipFilter) {
      this.filterOptions.relationshipType =
        relationshipFilter?.value as RelationshipType;
    }
  }
}
